import React, { useEffect } from "react";
import moment from "moment";
import Sign from "../../image/ramesh_sign.png";
import Stamp from "../../image/aditvertasstamp.png";
import LastPageStamp from "../../image/lastpagesign.png";
import { useLocation, useParams } from "react-router-dom";
import { fetchQuery } from "../../../utils/commonComponent/fetched";
import { generateCoverLetterPdf } from "./coverLetterPrint";
import { AddButton, CancelButton, SaveAndUpdate } from "../../../utils/Custom/Button";
import axiosWithToken from "../../../utils/commonComponent/axiosTokenConfig";
import { BASE_URL } from "../../../global";
import { toast } from "react-toastify";
import CommonForm from "../../../utils/commonComponent/commonForm";
import Text from "../../../utils/Custom/text";
import { AutoCompletes, TextFields } from "../../../utils/Custom/custominput";
import { extractBodyRows, extractHeaders, groupTableData } from "../../../utils/commonComponent/tableUtils";
import AddTable from "../../dynamicTables/dynamicTable";
import { handleApprovalIR_coverLetter, RejectionModalCoverLetter } from "./coverLetterUtils";
import DownloadPdfLoaderModal from "../../../utils/commonComponent/downloadPdfLoader";
import { getPermissions } from "../rbac/hasAccess";

const EditCoverLetter = (props) => {
  const margin = "px-6 md:px-20";
  const sectionGap = "mb-8";
  const lineGap = "mb-2 font-bold";
  const boldText = "font-bold";
  const centeredText = "text-center";

  const params = useParams();
  const location = useLocation();
  const permissions = getPermissions(props.moduleId);
  const isQRRoute = location.pathname.includes("/editCoverLetter/print/qr/");
  const PrintView = props?.print == true;
  const [inputStates, setInputStates] = React.useState({});
  const [IRDetails, setIRDetails] = React.useState({});
  const [referenceDocs, setReferenceDocs] = React.useState([]);
  const [attendees, setAttendees] = React.useState([]);
  const [measuringEquipments, setMeasuringEquipments] = React.useState([]);
  const [uploadedImages, setUploadedImages] = React.useState([]); // [{ imagePath, imagesName }]
  const [itemDetails, setItemDetails] = React.useState([]);
  const [tableData, setTableData] = React.useState([]);

  const [downloadPdfloading, setDownloadPdfloading] = React.useState(false);

  const [rejectionModalOpen, setRejectionModalOpen] = React.useState(false);
  const userType = localStorage.getItem("type") || "";
  const inspectorId = localStorage.getItem("id");
  const hasRole = ["2"].some((role) => (localStorage.getItem("roles") || "").split(",").includes(role)) || userType == 1;
  console.log(PrintView, hasRole, !inputStates?.approvedBy, !inputStates?.rejectedBy)


  const inputFields = [
    { type: "Textarea", label: "Introduction", stateKey: "introduction" },
    { type: "Textarea", label: "Subject", stateKey: "subjet" },
    { type: "Textarea", label: "Reference", stateKey: "reference" },
  ];

  const irDetailsinputFieldsShowOnly = [
    // {
    //   type: "Textarea",
    //   label: "Report No",
    //   stateKey: "reportNo",
    //   disabled: true,
    // },
    {
      type: "Textarea",
      label: "Project Name",
      stateKey: "projectName",
      disabled: true,
    },
    {
      type: "DatePicker",
      label: "Issue Date",
      stateKey: "issueDate",
      disabled: true,
    },
    {
      type: "DatePicker",
      label: "End Date",
      stateKey: "endvisitDate",
      disabled: true,
    },
    {
      type: "DatePicker",
      label: "Visit Date",
      stateKey: "visitDate",
      disabled: true,
    },
    // {
    //   type: "Autocomplete",
    //   label: "Client",
    //   stateKey: "clientId",
    //   options: "clients",
    //   valueKey: "id",
    //   getOptionLabelKey: "companyName",
    //   disabled: true,
    // },
    {
      type: "Textarea",
      label: "Purchase Order / Ref Doc",
      stateKey: "purchaseOrder",
      disabled: true,
    },
    // {
    //   type: "Textarea",
    //   label: "Client Reference",
    //   stateKey: "clientReference",
    //   disabled: true,
    // },
    {
      type: "Textarea",
      label: "Supplier / Sub-Supplier",
      stateKey: "supplierName",
      disabled: true,
    },
    {
      type: "Textarea",
      label: "Inspection Site Address",
      stateKey: "inspectionAddress",
      disabled: true,
    },
    {
      type: "Textarea",
      label: "Supplier Contact Name",
      stateKey: "supplierContactName",
      disabled: true,
    },
    {
      type: "Textarea",
      label: "Supplier Number/Email",
      stateKey: "supplierContactEmail",
      disabled: true,
    },
  ];


  const fetchInspectionReport = async () => {
    try {
      const query = `SELECT ir.*, c.companyName, u.userName AS inspectedByName, u.userSign AS inspectedBySign, a.userName AS approvedByName, a.userSign AS approvedBySign FROM IR ir LEFT JOIN clients c ON ir.clientId = c.id LEFT JOIN users u ON ir.inspectorId = u.id LEFT JOIN users a ON ir.approvedBy = a.id WHERE ir.jobRegisterInspectionId = ${params.id}`;
      const [inspectionData] = await fetchQuery(query);
      setIRDetails(inspectionData);

      if (inspectionData?.imagePath && inspectionData?.imagesName) {
        const paths = inspectionData.imagePath.split(",");
        const names = inspectionData.imagesName.split("||");
        const imageData = paths.map((p, i) => ({
          imagePath: p,
          imagesName: names[i] || "",
        }));
        setUploadedImages(imageData);
      }

      //  Fetch detail inspection fields
      const [detailData] = await fetchQuery(
        `SELECT * FROM IR_DetailInspection WHERE IRId = ${inspectionData?.id}`
      );
      setIRDetails((prev) => ({
        ...prev,
        inpectionDeatils: detailData?.inpectionDeatils || "",
        aiplIdentification: detailData?.aiplIdentification || "",
        attachments: detailData?.attachments || "",
        detailInspectionId: detailData?.id,
      }));

      // Fetch inspection items
      const itemQuery = `SELECT * FROM IR_inspectionItems WHERE IRId = ${inspectionData?.id}`;
      const itemResults = await fetchQuery(itemQuery);
      setItemDetails(itemResults);

      // Fetch reference docs
      const refQuery = `SELECT * FROM IR_referenceDocs WHERE IRId = ${inspectionData?.id}`;
      const refResults = await fetchQuery(refQuery);
      setReferenceDocs(refResults);

      // Fetch Attendees
      const attQuery = `SELECT * FROM IR_Attendees WHERE IRId = ${inspectionData?.id}`;
      const attResults = await fetchQuery(attQuery);
      setAttendees(attResults);

      // MEASURING/TESTING EQUIPMENt
      const eqQuery = `SELECT * FROM IR_MeasuringEquipments WHERE IRId = ${inspectionData?.id}`;
      const eqResults = await fetchQuery(eqQuery);
      setMeasuringEquipments(eqResults);
    } catch (error) {
      console.error("Error fetchInspectionReport:", error);
    }
  };

  const fetchCoverLetterDetails = async () => {
    try {
      const query = `SELECT * FROM IR_coverLetter WHERE jobRegisterId = ${params.id}`;
      const [coverLetterData] = await fetchQuery(query);
      if (coverLetterData) {
        setInputStates(coverLetterData);
      } else {
        setInputStates({ jobRegisterId: params.id });
      }
    } catch (error) {
      console.error("Error fetching cover letter details:", error);
    }
  };

  const fieldCharLimits = {
    clientId: 200,                        /*250*/
    subjet: 450,                          /*500*/
    reference: 450,                       /*500*/
    introduction: 900,                   /*1000*/

    referenceDoc: 450,                     /*500*/
    inspectionDetails: 1600,                 /*1700*/
    documentReview: 450,                   /*500*/
    inspectionIdentification: 450,         /*500*/
  }

  const updateInputObject = (key, value) => {
    const Limit = fieldCharLimits[key];
    if (Limit && typeof value === "string" && value.length > Limit) {
      toast.warning(`You have reached the maximum ${Limit} allowed text limit`);
      return;
    }
    setInputStates((prevInputStates) => ({
      ...prevInputStates,
      [key]: value,
    }));
  };

  // Function to delete existing table data from server
  const deleteExistingTableData = async (jobInspectionId) => {
    try {
      await Promise.all([
        axiosWithToken.post(`${BASE_URL}dynamic`, {
          query: `DELETE FROM dynamicTableHeader WHERE type = 3 AND jobInspectionId = ${jobInspectionId};`,
        }),
        axiosWithToken.post(`${BASE_URL}dynamic`, {
          query: `DELETE FROM dynamicTableBody WHERE type = 3 AND jobInspectionId = ${jobInspectionId};`,
        }),
      ]);
    } catch (error) {
      console.error("Error deleting existing table data:", error);
    }
  };

  const onSubmit = async () => {
    try {
      const { companyName, ...restInputStates } = inputStates;
      let payload = {
        ...restInputStates,
        reportNo: inputStates.reportNo,
        workName: inputStates.workName || inputStates.subjet || null,
        approvedBy: null,
        rejectedBy: null,
      };
      // Add inspectorId only if userType is "2"
      if (userType == 2) {
        payload.inspectorId = inspectorId;
        payload.requestApproval = 1;
      }
      const url = BASE_URL + `IR_coverLetter/${inputStates.id}`;
      await axiosWithToken.patch(url, payload);
      await deleteExistingTableData(params.id);

      // Save dynamic table data
      if (tableData.length > 0) {
        const allHeaders = [];
        const allBody = [];

        tableData.forEach((table) => {
          allHeaders.push(...extractHeaders(table, parseInt(params.id), 3));
          allBody.push(...extractBodyRows(table, parseInt(params.id), 3));
        });

        if (allHeaders.length) {
          await axiosWithToken.post(
            `${BASE_URL}dynamicTableHeader/bulk`,
            allHeaders
          );
        }
        if (allBody.length) {
          await axiosWithToken.post(
            `${BASE_URL}dynamicTableBody/bulk`,
            allBody
          );
        }
      }

      toast.success("Cover Letter Update Successfully!");
      setTimeout(() => window.location.reload(), 500);
    } catch (error) {
      console.error("Update failed:", error);
    }
  };

  // Fetch dynamic table data
  const fetchTableData = async () => {
    try {
      if (params.id && params.id !== "0") {
        const [headers, bodyData] = await Promise.all([
          fetchQuery(
            `SELECT * FROM dynamicTableHeader WHERE type = 3 AND jobInspectionId = ${params.id}`
          ),
          fetchQuery(
            `SELECT * FROM dynamicTableBody WHERE type = 3 AND jobInspectionId = ${params.id}`
          ),
        ]);

        if (headers.length > 0) {
          const grouped = groupTableData(
            headers,
            bodyData,
            parseInt(params.id)
          );
          setTableData(grouped);
        }
      }
    } catch (error) {
      console.error("Error fetching table data:", error);
    }
  };

  useEffect(() => {
    fetchInspectionReport();
    fetchCoverLetterDetails();
    fetchTableData(); // Fetch table data when component mounts
  }, []);

  // Auto-download PDF for QR route
  useEffect(() => {
    if (isQRRoute && inputStates.id) {
      // Wait a bit for all data to load
      const timer = setTimeout(() => {
        generateCoverLetterPdf(IRDetails, referenceDocs, inputStates, tableData, setDownloadPdfloading)
      }, 1500); // 1.5 seconds delay to ensure data is loaded
      return () => clearTimeout(timer);
    }
  }, [isQRRoute, inputStates.id]);

  return (
    <div className={isQRRoute ? "p-8" : ""}>
      {(permissions.pdfDownload || permissions.allAccess) && PrintView && !isQRRoute && (
        <div className="flex gap-5 justify-end ">
          <AddButton
            id="btn-add-outline"
            label="Download Cover Letter"
            onClick={() =>
              generateCoverLetterPdf(IRDetails, referenceDocs, inputStates, tableData, setDownloadPdfloading)
            }
          />
        </div>
      )}

      {!PrintView && (
        <Text variant="h3" bold className="text-blue-700 bg-blue-50 px-3 mb-5">
          Inspection Details
        </Text>
      )}

      {!PrintView && (
        <CommonForm
          inputStates={IRDetails}
          updateInputObject={updateInputObject}
          inputFields={irDetailsinputFieldsShowOnly}
        />
      )}

      <br />
      {!PrintView && (
        <Text variant="h3" bold className="text-blue-700 bg-blue-50 px-3 mb-5">
          Cover Letter Details
        </Text>
      )}

      {!PrintView && (
        <>
          <TextFields
            label="Report Number"
            // value={inputStates.reportNo || IRDetails?.reportNo || ""}
            value={inputStates.reportNo || ""}
            onChange={(e) => updateInputObject("reportNo", e.target.value)}
            multiline
            minRows={1}
            maxRows={10}
          />
          <br />
          <br />
          <TextFields
            label="Certificate Number"
            value={inputStates.certificateNo || ""}
            onChange={(e) => updateInputObject("certificateNo", e.target.value)}
            multiline
            minRows={1}
            maxRows={10}
          />
          <br />
          <br />
          <TextFields
            label="Client"
            value={inputStates.clientId || IRDetails?.clientId || ""}
            onChange={(e) => updateInputObject("clientId", e.target.value)}
            multiline
            minRows={1}
            maxRows={10}
          />
          <br />
          <br />

          <TextFields
            label="Subject"
            value={inputStates.subjet || IRDetails?.projectName || ""}
            // value={inputStates.subjet || ""}
            onChange={(e) => updateInputObject("subjet", e.target.value)}
            multiline
            minRows={1}
            maxRows={10}
          />
          <br />
          <br />
          <TextFields
            label="Reference"
            value={inputStates.reference ? inputStates.reference : IRDetails?.clientReference || ""}
            onChange={(e) => updateInputObject("reference", e.target.value)}
            multiline
            minRows={1}
            maxRows={10}
          />
          <br />
          <br />

          <TextFields
            label="Introduction"
            value={inputStates.introduction || ""}
            onChange={(e) => updateInputObject("introduction", e.target.value)}
            multiline
            minRows={1}
            maxRows={10}
          />
          <br />
          <br />

          <AddTable
            tables={tableData}
            setTables={setTableData}
            jobInspectionId={params.id}
            type={3}
          />

          {/* <TextFields
            label="Reference"
            value={inputStates.reference || ""}
            onChange={(e) => updateInputObject("reference", e.target.value)}
            multiline
            minRows={1}
            maxRows={10}
          />
          <br />
          <br /> */}
          {!PrintView && (
            <Text variant="h3" bold className="text-blue-700 bg-blue-50 px-3 mb-5">
              Release Note
            </Text>
          )}

          <TextFields
            label={"Contractor Consignee"}
            value={inputStates.contractorClient || ""}
            onChange={(e) =>
              updateInputObject("contractorClient", e.target.value)
            }
            multiline
            minRows={1}
            maxRows={10}
          />
          <br />
          <br />
          <TextFields
            label={"Contractor Name"}
            value={inputStates.contractorConsignee || ""}
            onChange={(e) =>
              updateInputObject("contractorConsignee", e.target.value)
            }
            multiline
            minRows={1}
            maxRows={10}
          />
          <br />
          <br />
          <TextFields
            label={"Name of Manufacturer/Supplier"}
            value={inputStates.supplierName || ""}
            onChange={(e) => updateInputObject("supplierName", e.target.value)}
            multiline
            minRows={1}
            maxRows={10}
          />
          <br />
          <br />
          <TextFields
            label={"Work Name"}
            value={inputStates.workName || inputStates.subjet || ""}
            onChange={(e) => updateInputObject("workName", e.target.value)}
            multiline
            minRows={1}
            maxRows={10}
          />
          <br />
          <br />
          {/* <TextFields
            label={"Reference Documents"}
            value={inputStates.referenceDoc || ""}
            onChange={(e) => updateInputObject("referenceDoc", e.target.value)}
            multiline
            minRows={1}
            maxRows={10}
          />
          <br />
          <br /> */}
          <TextFields
            label={"Inspection Details"}
            value={inputStates.inspectionDetails || ""}
            onChange={(e) =>
              updateInputObject("inspectionDetails", e.target.value)
            }
            multiline
            minRows={1}
            maxRows={10}
          />
          <br />
          <br />
          <TextFields
            label={"Documents Reviewed/Enclosed"}
            value={inputStates.documentReview || ""}
            onChange={(e) =>
              updateInputObject("documentReview", e.target.value)
            }
            multiline
            minRows={1}
            maxRows={10}
          />
          <br />
          <br />
          <TextFields
            label={"Remarks"}
            value={inputStates.remarks || ""}
            onChange={(e) => updateInputObject("remarks", e.target.value)}
            multiline
            minRows={1}
            maxRows={10}
          />
          <br />
          <br />
          <TextFields
            label={"Remarks2"}
            value={inputStates.remarks2 || ""}
            onChange={(e) => updateInputObject("remarks2", e.target.value)}
            multiline
            minRows={1}
            maxRows={10}
          />
          <br />
          <br />
          <TextFields
            label={"Inspection Identification"}
            value={inputStates.inspectionIdentification || ""}
            onChange={(e) =>
              updateInputObject("inspectionIdentification", e.target.value)
            }
            multiline
            minRows={1}
            maxRows={10}
          />
          <br />
          <br />
          <AutoCompletes
            label="Order Status"
            options={[
              { id: 1, label: "Complete" },
              { id: 2, label: "InComplete" },
              { id: 3, label: "Progress" },
            ]}
            value={inputStates.orderStatus || ""}
            onChange={(val) => updateInputObject("orderStatus", val)}
            isWidth
            valueKey="label"
            labelKey="label"
          />
          <br />
          <br />
        </>
      )}

      {PrintView && (
        <div className={`text-sm font-sans ${margin} py-12 text-justify`}>
          {/* Header Section */}
          <h1 className={`${centeredText} text-lg font-bold mb-8`}>
            COVER LETTER
          </h1>

          {/* Ref and Date */}
          <div className="flex justify-between">
            <p>
              <strong>{inputStates.reportNo || ""}</strong>
            </p>
            <p>
              <strong>
                Date: {moment(IRDetails?.issueDate).format("DD/MM/YYYY")}
              </strong>
            </p>
          </div>

          {/* Address To */}
          <div className={`${sectionGap}`}>
            <p className={lineGap}>To,</p>
            <pre className={lineGap}>{inputStates.clientId || IRDetails?.clientId || ""}</pre>
          </div>

          {/* Subject */}
          <div className={`${sectionGap}`}>
            <p className={`${boldText}`}>Subject:</p>
            <p>{inputStates.subjet || IRDetails?.projectName || ""}</p>
          </div>

          {/* Reference */}
          <div className={`${sectionGap}`}>
            <p className={`${boldText}`}>Reference:</p>
            <p>{inputStates.reference ? inputStates.reference : IRDetails?.clientReference}</p>
          </div>

          <p className={`${boldText} ${lineGap}`}>Dear Sir,</p>

          <p className={`${sectionGap}`}>{inputStates?.introduction}</p>

          {/* Table Section */}
          {/* Dynamic Table Section */}
          {tableData.length > 0 && tableData[0].body.length > 0 && (
            <div className={`${sectionGap} overflow-x-auto`}>
              <table className="table-auto border-collapse border border-black w-full text-center">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border border-black p-2">Sr.No.</th>
                    {tableData[0].columns.map((column, index) => (
                      <th key={column.id} className="border border-black p-2">
                        {column.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {tableData[0].body.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      <td className="border border-black p-2">
                        {rowIndex + 1}
                      </td>
                      {tableData[0].columns.map((column) => (
                        <td key={column.id} className="border border-black p-2">
                          {row[column.accessor] || ""}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Remarks */}
          <div className={`${sectionGap}`}>
            <p className={lineGap}>
              The inspection report for the same are attached herewith for your
              reference and dispatch clearance has been given for the quantity
              mentioned above.
            </p>
            <p className={lineGap}>Thanking you.</p>
          </div>

          {/* Images */}
          <div className="flex justify-between mt-10">
            <img src={Stamp} alt="Stamp" className="w-40 h-20" />
            <img src={Sign} alt="Sign" className="w-40 h-20" />
          </div>
          <h4 className="text-right mt-5 mr-2 pr-5 font-bold">Ramesh S. Jadhav</h4>
          <h4 className="text-right mt-2 mr-2 pr-5 font-bold">For BFI</h4>

          {/* Contractor Details Section */}
          <div className="mt-20">
            <h2 className="text-center font-bold mb-2 text-base">
              INSPECTION CERTIFICATE/RELEASE NOTE
            </h2>
            <p className="text-center mb-6">
              [CERTIFICATE NO. {inputStates?.certificateNo || inputStates?.reportNo} Date: {moment(IRDetails?.issueDate).format("DD/MM/YYYY")}]
            </p>

            <table className="table-auto border border-black w-full text-left">
              <tbody>
                <tr>
                  <td className="border border-black p-2 font-semibold w-1/3">
                    Contractor Consignee
                  </td>
                  <td className="border border-black p-2 text-center w-10">
                    :
                  </td>
                  <td className="border border-black p-2">
                    {inputStates?.contractorClient || ""}
                  </td>
                </tr>
                <tr>
                  <td className="border border-black p-2 font-semibold">
                    Contractor Name
                  </td>
                  <td className="border border-black p-2 text-center">:</td>
                  <td className="border border-black p-2">
                    {inputStates?.contractorConsignee || ""}
                  </td>
                </tr>
                <tr>
                  <td className="border border-black p-2 font-semibold">
                    Name of Manufacturer/Supplier
                  </td>
                  <td className="border border-black p-2 text-center">:</td>
                  <td className="border border-black p-2">
                    {inputStates?.supplierName}
                  </td>
                </tr>
                <tr>
                  <td className="border border-black p-2 font-semibold">
                    Work Name
                  </td>
                  <td className="border border-black p-2 text-center">:</td>
                  <td className="border border-black p-2">
                    {inputStates?.workName}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Inspection Details Section */}
          <div className="mt-12 space-y-4">
            <div>
              <h3 className="font-semibold mb-1">REFERENCE DOCUMENTS:</h3>
              <ul className="list-decimal ml-5">
                {referenceDocs?.map((doc) => (
                  <li key={doc.id}>{doc.documents}</li>
                ))}
                {IRDetails?.reportNo && (<li>{IRDetails.reportNo}</li>)}
              </ul>
            </div>

            <div>
              <h3 className="font-semibold mb-1">INSPECTION DETAILS:-</h3>
              <pre className="whitespace-pre-wrap break-words">{inputStates.inspectionDetails}</pre>
            </div>

            <div>
              <h3 className="font-semibold mb-1">
                DOCUMENTS REVIEWED/ENCLOSED:-
              </h3>
              <pre className="whitespace-pre-wrap break-words">{inputStates.documentReview}</pre>
            </div>

            <div>
              <h3 className="font-bold mb-1">
                REMARKS :-
                <span className="font-semibold ml-2">{inputStates?.remarks}</span>
              </h3>
              <h3 className="font-bold mb-1">
                <span className="font-semibold ml-2">{inputStates?.remarks2}</span>
              </h3>
            </div>

            <div>
              <h3 className="font-bold mb-1">
                INSPECTION IDENTIFICATION :-
                <span className="font-semibold ml-2">
                  {inputStates?.inspectionIdentification}
                </span>
              </h3>
            </div>

            <div>
              <h3 className="font-bold mb-1">
                Order Status :-
                <span className="font-semibold ml-2">
                  {inputStates?.orderStatus}
                </span>
              </h3>
            </div>
          </div>
          <div className="flex justify-between mt-10">
            <img src={Stamp} alt="Stamp" className="w-40 h-20" />
            <img
              src={IRDetails?.inspectedBySign}
              alt="LastPageStamp"
              className="w-40 h-20"
            />
          </div>
          <h4 className="text-right mt-5 mr-2 pr-5 font-bold">Inspection Engineer</h4>
        </div>
      )}

      {!PrintView && (
        <div className="flex gap-10 mt-5 justify-end ">
          <CancelButton
            id="btn-cancel"
            label="Cancel"
            outline
            onClick={() => {
              if (window.confirm("Are you sure you want to cancel?")) {
                window.history.back();
              }
            }}
          />
          {!(userType == 2 && inputStates?.requestApproval == 2) &&
            (permissions.save || permissions.create || permissions.allAccess) && (
              <SaveAndUpdate
                id="btn-add-outline"
                label={"Save"}
                onClick={onSubmit}
              />
            )}
        </div>
      )}

      <div className="flex gap-3 mt-10">
        {!PrintView && hasRole && !inputStates?.approvedBy && !inputStates?.rejectedBy && inputStates?.requestApproval == 2 &&
          (
            <>
              <AddButton
                id="btn-add-outline"
                label="Approve"
                variant="approve"
                onClick={() => handleApprovalIR_coverLetter([params.id])}
              />
              <AddButton
                id="btn-reject"
                label="Reject"
                variant="delete"
                onClick={() => setRejectionModalOpen(true)}
                style={{ backgroundColor: '#ef4444' }}
              />
            </>
          )}
      </div>
      <br />
      <br />
      {/* Add the modal component before the closing div */}
      <RejectionModalCoverLetter
        open={rejectionModalOpen}
        onClose={() => setRejectionModalOpen(false)}
        selectedIds={[params.id]}
        onSuccess={() => window.location.reload()}
      />
      {downloadPdfloading && (
        <DownloadPdfLoaderModal
          loading={downloadPdfloading}
          name={"Cover Letter"}
        />
      )}
    </div>
  );
};

export default EditCoverLetter;
